<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18 2H6a1 1 0 00-1 1v18a1 1 0 001 1h12a1 1 0 001-1V3a1 1 0 00-1-1zm-1 18H7V4h10z"/><path d="M8.5 10.5h7a.5.5 0 00.5-.5V5.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V10a.5.5 0 00.5.5zM9 6h6v3.5H9zM8.5 19h7a.5.5 0 00.5-.5V14a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v4.5a.5.5 0 00.5.5zm.5-4.5h6V18H9zM15.5 11.5h-2a.5.5 0 000 1h2a.5.5 0 000-1z"/></svg>